// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__jiF3w","heroContent":"Hero_heroContent__fRwWi","fadeInUp":"Hero_fadeInUp__UyuBS","heroTitle":"Hero_heroTitle__UU-OE","heroSubtitle":"Hero_heroSubtitle__TySuL"};